import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OInput from '../../../UI/FormControls/OInput';
import OAutocomplete from '../../../UI/MuiAutocomplete';
import useHttp from '../../../../hooks/use-http';

const Inputs = ({ formValues, setFormValues, masine }) => {
  const { sendRequest: vratiKarakteristike, data: kategorijeData } =
    useHttp('');
  const { t, i18n } = useTranslation();

  const vratiKategorije = () => {
    const configMasine = {
      url: 'Combo/vrati_kategorije_dokumenatacije',
    };
    vratiKarakteristike(configMasine);
  };
  useEffect(() => {
    vratiKategorije();
  }, []);
  const handleChange = (item) => {
    setFormValues((curr) => {
      return { ...curr, [item.target.name]: item.target.value };
    });
  };
  const handleClickKategorija = (item) => {
    setFormValues((curr) => {
      return {
        ...curr,
        idKategorije: item.id,
        nazivKategorije: item.vrednost,
      };
    });
  };
  const handleClickMasina = (item) => {
    setFormValues((curr) => {
      return {
        ...curr,
        idTipaMasine: item.id,
        nazivTipaMasine: item.vrednost,
      };
    });
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '2px',
        marginBottom: '10px',
      }}
    >
      <OInput
        label="Naziv kategorije *"
        name="naziv"
        value={formValues.naziv}
        handleChange={handleChange}
        touched={formValues.touchedNaziv}
        setTouched={() => {
          setFormValues((curr) => {
            return { ...curr, touchedNaziv: true };
          });
        }}
        errorMessage={`Naziv  ${t('isRequired')}`}
        style={{ width: '250px' }}
      />
      <OAutocomplete
        data={masine}
        value={formValues.nazivTipaMasine || ''}
        handleClick={handleClickMasina}
        label="Tip mašine *"
        style={{ width: '250px' }}
      />
      <OAutocomplete
        data={kategorijeData}
        value={formValues.nazivKategorije || ''}
        handleClick={handleClickKategorija}
        label="Kategorija *"
        style={{ width: '250px' }}
      />
      <OInput
        label="Metadata *"
        name="metadata"
        value={formValues.metadata}
        handleChange={handleChange}
      />
      <OInput
        label="Opis"
        name="opis"
        value={formValues.opis}
        handleChange={handleChange}
      />
    </div>
  );
};

export default Inputs;
